import { createFileRoute } from "@tanstack/react-router";
import MentiuniLegale from "@/pages/legal/MentiuniLegale";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/mentiuni-legale/")({
  head: () => routeHead("/mentiuni-legale/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <MentiuniLegale />
  );
}
